module.exports = __webpack_public_path__ + "img/serifnew_box02.ef390bb2.jpg";